import * as React from "react";
import styled from "styled-components";
import { Release } from "types/release";
import { Status } from "components/Releases/Status";
import moment from "moment/moment";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Copy from "assets/copy.svg";
import {FormattedMessage} from "react-intl";

export const getColumns = (onCopy: () => void) => [
  {
    body: (data: Release) => {
      return (
        <CoverWrapper>
          <Cover cover={data.cover_url} />
          <Status status={data.status} isMinimalistic={true} />
        </CoverWrapper>
      )
    },
    field: 'cover_url',
    header: <div />
  },
  {
    body: (data: Release) => data.title,
    columnKey: 'title',
    field: 'title',
    header: (
      <StyledHeader>
        <FormattedMessage id="Labels.Columns.Title" defaultMessage="Title" />
      </StyledHeader>
    )
  },
  {
    body: (data: Release) => data.version || '-',
    columnKey: 'version',
    field: 'version',
    header: (
      <StyledHeader>
        <FormattedMessage id="Labels.Columns.ReleaseVersion" defaultMessage="Release version" />
      </StyledHeader>
    )
  },
  {
    body: (data: Release) => {
      const ean = data.ean;
      return (
        <EANContainer>
          {ean || '-'}
          <EANCopyIconContainer>
            <CopyToClipboard text={ean || ''} onCopy={onCopy}><Copy /></CopyToClipboard>
          </EANCopyIconContainer>
        </EANContainer>
      );
    },
    columnKey: 'ean',
    field: 'ean',
    header: (
      <StyledHeader>
        <FormattedMessage id="Labels.Columns.EAN" defaultMessage="EAN" />
      </StyledHeader>
    )
  },
  {
    body: (data: Release) => data.created_at ? moment(data.created_at).format('DD.MM.YYYY') : '-',
    columnKey: 'created_at',
    field: 'created_at',
    header: (
      <StyledHeader>
        <FormattedMessage id="Labels.Columns.DateAdded" defaultMessage="Date added" />
      </StyledHeader>
    )
  },
  {
    body: (data: Release) => data.release_date ? moment(data.release_date).format('DD.MM.YYYY') : '-',
    columnKey: 'release_date',
    field: 'release_date',
    header: (
      <StyledHeader>
        <FormattedMessage id="Labels.Columns.ReleaseDate" defaultMessage="Release date" />
      </StyledHeader>
    )
  },
];

const CoverWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const Cover = styled.div<{ cover: string | null }>`
  height: 25px;
  width: 25px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  background-color: ${props => props.cover ? 'transparent' : 'darkslategray'};
  background-image: url("${props => props.cover}");
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7C7C7C;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  height: 40px;
`;

const EANContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const EANCopyIconContainer = styled.div`
  cursor: pointer;
`;
